import { format as formatDT } from "date-fns";
import { Immutable } from "immer";
import React, { useId } from "react";
import SVG from "react-inlinesvg";
import { Tooltip } from "react-tooltip";
import { t } from "ttag";

import QuestionMarkCircleIcon from "../../../img/icons/question-mark-circle-filled.svg";

import styles from "./index.module.scss";

type IPricingDisclaimerTooltipProps = Immutable<{
    tooltipText: string;
    className?: string;
}>;

export const PricingDisclaimerTooltip = (
    props: IPricingDisclaimerTooltipProps,
): React.JSX.Element => {
    const tipId = useId();

    if (!props.tooltipText) {
        return <></>;
    }

    return (
        <>
            <span
                data-tooltip-id={tipId}
                tabIndex={0}
                className={props.className}
                style={{
                    display: "inline-block",
                    cursor: "pointer",
                    verticalAlign: "super",
                    fontSize: "0.75em",
                    marginLeft: "2px",
                }}
            >
                <SVG
                    className="tooltip__handle"
                    src={QuestionMarkCircleIcon}
                    aria-label="Pricing disclaimer information"
                    style={{
                        pointerEvents: "none",
                        width: "12px",
                        height: "12px",
                    }}
                />
            </span>
            <Tooltip
                id={tipId}
                className="tooltip__content"
                delayHide={100}
                delayShow={200}
                globalCloseEvents={{ escape: true }}
                place="top"
            >
                {props.tooltipText}
            </Tooltip>
        </>
    );
};

export const PricingDisclaimerText = (
    props: Immutable<{
        lastFullPriceDate: Date | null;
    }>,
): React.JSX.Element | null => {
    if (!props.lastFullPriceDate) {
        return null;
    }
    const formattedDate = formatDT(props.lastFullPriceDate, "P");
    return (
        <div className={`basket-line__disclaimers ${styles.pricingDisclaimer}`}>
            {t`Last offered at full price on ${formattedDate}`}
        </div>
    );
};
